import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';

// icon
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';
import FormModal from '../../../Utils/FormModal';
import TableElement from '../../../Utils/elements/TableElement';

export default function CoMembers() {
    // input value
    const [data, setData] = useState({
        coMembersCustomerName: '',
        coMembersMobileNumber: '',
        membership: false,
        package: false,
        giftCard: false,
    });

    // Edit modal
    const [formModalShow, setShowFormModal] = useState(false);
    const handleCoMembersEdit = () => setShowFormModal(true);
    const handleFormModalClose = () => setShowFormModal(false);

    const handleInputChange = (index, field, value) => {
        setData({ ...data, [field]: value });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setShowFormModal(false);
    };

    const rows = [
        {
            columns: [
                {
                    size: { md: 12 }, label: 'Customer Name', type: 'select', name: 'coMembersCustomerName', id: 'coMembersCustomerName', value: data.coMembersCustomerName, errormsg: '',
                    options: [
                        { value: '', label: 'Select Customer' }, { value: 1, label: 'Select One' }, { value: 2, label: 'Select Two' },
                        // ...country.map((c, i) => ({ value: c.calling_code, label: c.short_name }))
                    ],
                },
                { size: { lg: 12 }, label: 'Mobile Number', type: 'number', name: 'coMembersMobileNumber', id: 'coMembersMobileNumber', placeholder: '(+91) 1234 5678 90', value: data.coMembersMobileNumber, errormsg: '', },
                {
                    size: { lg: 12 }, type: 'checkboxes',
                    checkboxes: [
                        { name: 'membership', id: 'membership-checkboxes', value: data.membership, label: 'Membership', },
                        { name: 'package', id: 'package-checkboxes', value: data.package, label: 'Package', },
                        { name: 'giftCard', id: 'gift-card-checkboxes', value: data.giftCard, label: 'Gift Card', },
                    ]
                },
            ]
        }
    ];
    const Buttons = [
        { variant: "primary", text: "Save", onClick: handleFormModalClose },
        { variant: "secondary", text: "Cancel", onClick: handleFormModalClose },
    ]

    // Co-Members Table
    const ctCoMembers = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Co Members Name', 'Co Members Mobile Number', 'Co Members Permissions', 'Action'],
        tbody: [{
            comembersname: { type: 'text', text: 'Jennifer V. Pierce' },
            comembersmobilenumber: { type: 'text', text: '+91 1234 5678 90' },
            comemberspermissions: { type: 'text', text: 'Yes' },
            action: { type: 'button', btnColor: 'light', btnSize: 'sm', text: 'View Invoice' }
        }]
    };
    return (
        <>
            <div className='d-flex justify-content-between align-items-center mb-3'>
                <Card.Title className='mb-0'>Co-Members Details</Card.Title>
                <Button variant="outline-primary" onClick={handleCoMembersEdit}><Icon path={mdiPlus} className="btn-icon me-1" /> Add Co Members</Button>
            </div>

            {/* Co Members Table */}
            <TableElement tableClass={ctCoMembers.tableClass} thead={ctCoMembers.thead} tbodydata={ctCoMembers.tbody} />

            {/* From Modal */}
            <FormModal title="Add Co Members" modalSize="md" formModalShow={formModalShow} Buttons={Buttons} handleFormModalClose={handleFormModalClose} rows={rows} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
        </>
    )
}
